import { useCallback } from 'react';
import { Modal } from '../ui';
import { CommissionTable } from './CommissionTable';
import { resellersService, type CommissionQuery, type Reseller } from '../../services/resellers.service';

interface ResellerCommissionsModalProps {
  reseller: Reseller;
  onClose: () => void;
  onUpdated: () => void;
}

// Super admin: one reseller's commission rows; pending rows can be marked paid
export const ResellerCommissionsModal = ({ reseller, onClose, onUpdated }: ResellerCommissionsModalProps) => {
  const load = useCallback(
    (query: CommissionQuery) => resellersService.getCommissions(reseller.id, query),
    [reseller.id],
  );

  return (
    <Modal
      isOpen
      onClose={onClose}
      title="Commissions"
      subtitle={`${reseller.firstName} ${reseller.lastName}${reseller.companyName ? ` · ${reseller.companyName}` : ''}`}
      size="xl"
      contentClassName="p-6"
    >
      <CommissionTable loadCommissions={load} resellerId={reseller.id} onPaid={onUpdated} />
    </Modal>
  );
};
